<template>
  <div class="right">

    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">分红情况</div>
      <div class="centerCon">
        <div @click="downloadFn(0)" class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <el-table
          size="mini"
          :data="tableData"
          :header-cell-style="cellStyle">
          <el-table-column width="60" :show-overflow-tooltip="true" label="序号">
            <template slot-scope="scope">
              {{scope.$index+1+(currentPage-1)*limit}} 
            </template>
          </el-table-column>
          <el-table-column
            prop="announceDate"
            label="公告日期">
          </el-table-column>
          <el-table-column
            prop="shareYear"
            label="分红年度">
          </el-table-column>
          <el-table-column label="分红方案(每10股)" align="center">
            <el-table-column
              prop="shareSg"
              label="送股">
            </el-table-column>
            <el-table-column
              prop="shareZz"
              label="转赠">
            </el-table-column>
            <el-table-column
              prop="sharePx"
              label="派息">
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="recordDate"
            label="股权登记日">
          </el-table-column>
          <el-table-column
            prop="deleteDate"
            label="除权除息日">
          </el-table-column>
          <el-table-column
            prop="tradeDate"
            label="红股上市日">
          </el-table-column>
        </el-table>
      </div>
      <div style="width:100%;margin-top:40px;">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          background
          :current-page="currentPage"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      tableData:[],
      companyList:[],
      paramsData:{},//URL参数集合
      offset:0,//page
      limit:10,
      total:0,
      currentPage:1
    };
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.fetchTable();//获取表格数据
    },
    cellStyle(row,column,rowIndex,columnIndex){
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    // 分页函数
    handleCurrentChange(val) {//当前页
      this.currentPage = val;
      this.offset = (val-1)*this.limit;
      this.fetchTable();
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/capitalStructure/downProfitShareData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    fetchTable(){
        let _this = this;
        let params = { 
          stockCode:this.paramsData.stockCode,  
          enterpriseCode:this.paramsData.enterpriseCode,  
          offset:this.offset,
          limit:this.limit
        }
        api.distriGetPay(params).then(res=>{
            let data = res.data.rows;
            _this.total = res.data.total;
            _this.tableData = data;
        })   
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #DFDFDF; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #DFDFDF; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; }
.mailTable .column { background-color: #F7F7F7; color: #333333; font-size:14px;font-weight:bold;width:20%;}
</style>


// WEBPACK FOOTER //
// src/view/distribution/getpay.vue